"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeBase = void 0;

var _styles = require("@mui/material/styles");

var _accordion = require("./dhig2021-theme-base/accordion");

var _alert = require("./dhig2021-theme-base/alert");

var _autocomplete = require("./dhig2021-theme-base/autocomplete");

var _buttonGroup = require("./dhig2021-theme-base/button-group");

var _button = require("./dhig2021-theme-base/button");

var _card = require("./dhig2021-theme-base/card");

var _checkbox = require("./dhig2021-theme-base/checkbox");

var _chip = require("./dhig2021-theme-base/chip");

var _container = require("./dhig2021-theme-base/container");

var _datePicker = require("./dhig2021-theme-base/date-picker");

var _dialog = require("./dhig2021-theme-base/dialog");

var _divider = require("./dhig2021-theme-base/divider");

var _filledInput = require("./dhig2021-theme-base/filled-input");

var _formControl = require("./dhig2021-theme-base/form-control");

var _formGroup = require("./dhig2021-theme-base/form-group");

var _formHelperText = require("./dhig2021-theme-base/form-helper-text");

var _formLabel = require("./dhig2021-theme-base/form-label");

var _grid = require("./dhig2021-theme-base/grid");

var _iconButton = require("./dhig2021-theme-base/icon-button");

var _inputLabel = require("./dhig2021-theme-base/input-label");

var _input = require("./dhig2021-theme-base/input");

var _link = require("./dhig2021-theme-base/link");

var _listSubheader = require("./dhig2021-theme-base/list-subheader");

var _menuItem = require("./dhig2021-theme-base/menu-item");

var _outlinedInput = require("./dhig2021-theme-base/outlined-input");

var _pagination = require("./dhig2021-theme-base/pagination");

var _popover = require("./dhig2021-theme-base/popover");

var _popper = require("./dhig2021-theme-base/popper");

var _progress = require("./dhig2021-theme-base/progress");

var _radio = require("./dhig2021-theme-base/radio");

var _select = require("./dhig2021-theme-base/select");

var _skeleton = require("./dhig2021-theme-base/skeleton");

var _snackbar = require("./dhig2021-theme-base/snackbar");

var _svgIcon = require("./dhig2021-theme-base/svg-icon");

var _table = require("./dhig2021-theme-base/table");

var _tabs = require("./dhig2021-theme-base/tabs");

var _toggleButtonGroup = require("./dhig2021-theme-base/toggle-button-group");

var _toggleButton = require("./dhig2021-theme-base/toggle-button");

var _toolbar = require("./dhig2021-theme-base/toolbar");

var _tooltip = require("./dhig2021-theme-base/tooltip");

var _treeItem = require("./dhig2021-theme-base/tree-item");

var _treeView = require("./dhig2021-theme-base/tree-view");

var _typography = require("./dhig2021-theme-base/typography");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Returns a MUI-compatible theme base object
 */
var getThemeBase = function getThemeBase(_ref) {
  var _additionalThemeOptio, _additionalThemeOptio2;

  var _ref$paletteType = _ref.paletteType,
      paletteType = _ref$paletteType === void 0 ? "light" : _ref$paletteType,
      themeData = _ref.themeData,
      additionalThemeOptions = _objectWithoutProperties(_ref, ["paletteType", "themeData"]);

  // Modify rem-based primitive and token values for cases in which the
  // root font size of the page is not set to the default 16px
  var htmlFontSize = (_additionalThemeOptio = additionalThemeOptions === null || additionalThemeOptions === void 0 ? void 0 : (_additionalThemeOptio2 = additionalThemeOptions.typography) === null || _additionalThemeOptio2 === void 0 ? void 0 : _additionalThemeOptio2.htmlFontSize) !== null && _additionalThemeOptio !== void 0 ? _additionalThemeOptio : 16;
  var htmlFontSizeRatio = htmlFontSize / 16;

  var primitives = _objectSpread(_objectSpread({}, themeData.primitives), {}, {
    fontSizes: Object.entries(themeData.primitives.fontSizes).reduce(function (acc, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          fontSize = _ref3[1];

      acc[key] = htmlFontSizeRatio === 1 ? fontSize : "calc(".concat(fontSize, " / ").concat(htmlFontSizeRatio, ")");
      return acc;
    }, {})
  });

  var typographyTokens = Object.entries(themeData.tokens.typography).reduce(function (acc, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        token = _ref5[1];

    acc[key] = _objectSpread(_objectSpread({}, token), {}, {
      fontSize: htmlFontSizeRatio === 1 ? token.fontSize : "calc(".concat(token.fontSize, " / ").concat(htmlFontSizeRatio, ")")
    });
    return acc;
  }, {});

  var tokens = _objectSpread(_objectSpread({}, themeData.tokens), {}, {
    typography: typographyTokens
  }); // Create a MUI-compatible breakpoint configuration based on theme data


  var breakpointValues = Object.entries(tokens.grid).reduce(function (acc, _ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        value = _ref7[1];

    acc.keys.push(key);
    acc.values[key] = parseInt(value.breakpoint, 10);
    return acc;
  }, {
    keys: [],
    values: {}
  });

  var _createTheme = (0, _styles.createTheme)({
    breakpoints: breakpointValues
  }),
      breakpoints = _createTheme.breakpoints;

  var transitionValues = Object.entries(tokens.transitions).reduce(function (acc, _ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
        key = _ref9[0],
        value = _ref9[1];

    acc.duration[key] = value.transitionDuration;
    acc.easing[key] = value.transitionTimingFunction;
    return acc;
  }, {
    duration: {},
    easing: {}
  });
  /* istanbul ignore next */

  return {
    breakpoints: breakpoints,
    direction: "ltr",
    palette: {
      // Light and dark variants may be adjusted as we work on related components.
      common: {
        black: primitives.colors.primary.black,
        white: primitives.colors.primary.white
      },
      type: paletteType,
      primary: {
        main: paletteType === "light" ? primitives.colors.primary.black : primitives.colors.primary.white
      },
      error: {
        main: tokens.colors["ink-error"].color
      },
      success: {
        main: tokens.colors["ink-success"].color
      },
      text: {
        primary: primitives.colors.primary.black,
        secondary: primitives.colors.primary.white
      },
      divider: "rgba(0, 0, 0, 0.1)",
      background: {
        paper: tokens.colors.background.color,
        // Background for Card, Tabs
        default: tokens.colors.background.color
      }
    },
    typography: _objectSpread({
      fontFamily: primitives.fontFamilies.default,
      fontWeightLight: primitives.fontWeights.default,
      fontWeightRegular: primitives.fontWeights.default,
      fontWeightMedium: primitives.fontWeights.emphasized,
      fontWeightBold: primitives.fontWeights.display,
      body1: tokens.typography["body-copy-medium"]
    }, typographyTokens),
    spacing: Object.entries(primitives.spacings).map(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
          _ = _ref11[0],
          value = _ref11[1];

      return value;
    }),
    transitions: _objectSpread({}, transitionValues),
    zIndex: {},
    primitives: primitives,
    tokens: tokens,
    components: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _accordion.makeAccordionStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _alert.makeAlertStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _autocomplete.makeAutocompleteStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _buttonGroup.makeButtonGroupStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _button.makeButtonStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _card.makeCardStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _checkbox.makeCheckboxStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _chip.makeChipStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _container.makeContainerStyles)()), (0, _datePicker.makeDatePickerStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _dialog.makeDialogStyles)({
      breakpoints: breakpoints,
      htmlFontSize: htmlFontSize,
      paletteType: paletteType,
      primitives: primitives,
      tokens: tokens
    })), (0, _divider.makeDividerStyles)({
      tokens: tokens
    })), (0, _filledInput.makeFilledInputStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _formControl.makeFormControlStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _formGroup.makeFormGroupStyles)({
      primitives: primitives
    })), (0, _formHelperText.makeFormHelperTextStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _formLabel.makeFormLabelStyles)({
      tokens: tokens
    })), (0, _grid.makeGridStyles)({
      breakpoints: breakpoints,
      primitives: primitives,
      tokens: tokens
    })), (0, _iconButton.makeIconButtonStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _inputLabel.makeInputLabelStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _input.makeInputStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _link.makeLinkStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _listSubheader.makeListSubheaderStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _menuItem.makeMenuItemStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _outlinedInput.makeOutlinedInputStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _pagination.makePaginationStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _popover.makePopoverStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _popper.makePopperStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _progress.makeProgressStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _radio.makeRadioStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _select.makeSelectStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _skeleton.makeSkeletonStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _snackbar.makeSnackbarStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _svgIcon.makeSvgIconStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _table.makeTableStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _tabs.makeTabsStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _toggleButtonGroup.makeToggleButtonGroupStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _toggleButton.makeToggleButtonStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _toolbar.makeToolbarStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _tooltip.makeTooltipStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _treeItem.makeTreeItemStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _treeView.makeTreeViewStyles)({
      primitives: primitives,
      tokens: tokens
    })), (0, _typography.makeTypographyStyles)({
      tokens: tokens
    }))
  };
};

exports.getThemeBase = getThemeBase;